/**
 * /payroll/statutory-bonus — statutory bonus under the Code on Wages
 * (docs/superpowers/specs/2026-10-21-payroll-statutory-accuracy.md §4, B6).
 *
 * HR-admin (PayrollModuleShell's role gate mirrors the backend's
 * payrollRole). Reached from the Payroll module strip, the link tile on the
 * Statutory page and the Oct–Nov strip on the payroll home; under the
 * /payroll prefix (Run surface) — not a URL-only orphan.
 */

import { createFileRoute, useParams } from "@tanstack/react-router";
import { PayrollModuleShell } from "@/components/shared/payroll-module-shell";
import { StatutoryBonusPage } from "@/components/payroll/statutory-bonus-page";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/payroll/statutory-bonus")({
  component: StatutoryBonusRoute,
});

function StatutoryBonusRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <PayrollModuleShell
      title="Statutory Bonus"
      description="Work out each person's bonus for the year, check it, and add it to this month's payroll."
    >
      <StatutoryBonusPage tenantSlug={tenantSlug} />
    </PayrollModuleShell>
  );
}
